import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/external-sftp/:vendorApiId',
      component: component('views/external-sftp-configuration/ExternalSftpConfigurationView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/ExternalSftp` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/external-sftp/:vendorApiId',
          name: 'AppCustomer/VendorApis/ExternalSftpConfiguration',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/ExternalSftpConfiguration/Settings', params }),
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/ExternalSftpConfiguration/Settings',
          component: component('views/external-sftp-configuration/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
